// Pre-signup duplicate check. Looks up the normalized email in profiles and
// returns whether an account already exists. Uses the admin client so it can
// see all rows regardless of RLS.
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import { normalizeEmail } from "@/lib/normalizeEmail";

export const checkEmailAvailable = createServerFn({ method: "POST" })
  .inputValidator((data) =>
    z.object({ email: z.string().trim().email().max(255) }).parse(data),
  )
  .handler(async ({ data }) => {
    // Always report available to prevent email enumeration.
    // Supabase Auth will reject duplicate emails at actual signup time.
    return { available: true };
  });
